import SchoolResidentialType from './SchoolResidentialType.page';

export default SchoolResidentialType;
